import React from "react";
import "./Platforms.css";
import homeegramImg from "../Assets/Homeegram Web 02 1.png";
import homeeshareImg from "../Assets/Homeeshare Web 02 1.png";
import homeemagImg from "../Assets/Homeemag Web 02 1.png";

const platforms = [
  {
    name: "Homeegram",
    img: homeegramImg,
    url: "/homeegram", // Internal route
  },
  {
    name: "Homeeframes",
    img: homeemagImg,
    url: "/homeeframes", // External URL for Homeeframes
  },
  {
    name: "Homeeshare",
    img: homeeshareImg,
    url: "/homeeshare", // Internal route
  },
];

const Platforms = () => {
  const handleClick = (url) => {
    // Check if URL is external (starts with http or https)
    if (url.startsWith("http")) {
      // Open external URL in a new tab
      window.open(url, "_blank", "noopener,noreferrer");
    } else {
      // Navigate to internal route
      window.location.href = url;
    }
  };

  return (
    <div className="platforms-section">
      <h1 className="platforms-title">
        Our Platforms<span className="platforms-dot">.</span>
      </h1>
      <div className="platforms-grid">
        {platforms.map((platform) => (
          <div
            className="platform-cards"
            key={platform.name}
            onClick={() => handleClick(platform.url)}
            style={{ cursor: "pointer" }}
          >
            <img
              src={platform.img}
              alt={platform.name}
              className="platform-image"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Platforms;
